import { Box, IconButton, Stack, SxProps, Typography } from "@mui/material";
import { useStyles } from "./style";
import { Remove } from "svgr/remove";
import { IBookingSettings } from "pages/booking/interface";

interface IProps {
  services: Array<any>;
  onRemove?: (serviceId: string, index: number) => void;
  sx?: SxProps;
  maxServicesAllow?: number;
  bookingSettings: IBookingSettings;
}

const ServicesBox = ({
  services,
  onRemove,
  sx,
  maxServicesAllow,
  bookingSettings,
}: IProps) => {
  const classes = useStyles();
  return (
    <Box className={classes.root} sx={sx}>
      <Box className={classes.serviceTable}>
        {services.map((service, idx) => (
          <Stack
            direction="row"
            key={service.serviceId}
            className={classes.serviceRow}
            borderTop={idx !== 0 ? "1px dashed #96C6F6" : "0"}
            pt={idx === 0 ? "0 !important" : ""}
            pb={idx === services.length - 1 ? "0 !important" : ""}
          >
            <Box>
              <Typography fontWeight={600} color="#061340">
                {service.serviceName}
              </Typography>
              <Typography fontSize={14} color="#637381">
                with {service.staffName}
              </Typography>
            </Box>
            {!!onRemove ? (
              <IconButton
                onClick={() => onRemove(service.serviceId, idx)}
                color="primary"
              >
                <Remove />
              </IconButton>
            ) : bookingSettings.showServicePrice ? (
              <Typography color="#061340" fontWeight={700}>
                ${service.servicePrice}
              </Typography>
            ) : (
              <></>
            )}
          </Stack>
        ))}
      </Box>
      {!!onRemove && services.length === maxServicesAllow && (
        <Typography fontSize="12px" className={classes.helperText} mt={1}>
          {`You can book a maximum of ${maxServicesAllow} services in one appointment. Please remove an existing service to add a new one, or choose "Next" to pick a date and time for your appointment.`}
        </Typography>
      )}
    </Box>
  );
};

export default ServicesBox;
